import { useState } from 'react';
import './LoginPage.css';

/** 관리자 로그인 페이지 */
export default function LoginPage({ onLogin, kickMessage }) {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id.trim() || !pw.trim()) {
      setError('아이디와 비밀번호를 입력해 주세요.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const res = await fetch('/api/accounts/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ strID: id.trim(), strPW: pw }),
      });
      if (!res.ok) {
        let msg = res.status === 403
          ? '정지된 계정입니다. 관리자에게 문의하세요.'
          : 'ID 또는 비밀번호가 올바르지 않습니다.';
        try {
          const body = await res.json();
          if (body.message) msg = body.message;
        } catch (_) {}
        setError(msg);
        return;
      }
      const data = await res.json(); // { token, account }
      if (onLogin) onLogin(data);
    } catch (_) {
      setError('서버에 연결할 수 없습니다. 백엔드(8080) 실행 상태를 확인해 주세요.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <img
          src="/images/Header_Logo_Acetec.png"
          alt="AceTec"
          className="login-logo"
        />
        <h1 className="login-title">관리자 로그인</h1>
        <p className="login-sub">Admin Console</p>
        {kickMessage && <p className="login-kick">{kickMessage}</p>}

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <div className="fg">
            <label htmlFor="login-id">아이디</label>
            <input
              id="login-id"
              type="text"
              autoComplete="username"
              placeholder="아이디를 입력하세요"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
          </div>

          <div className="fg">
            <label htmlFor="login-pw">비밀번호</label>
            <input
              id="login-pw"
              type="password"
              autoComplete="current-password"
              placeholder="비밀번호를 입력하세요"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button
            type="submit"
            className="btn-primary login-btn"
            disabled={submitting}
          >
            {submitting ? '로그인 중…' : '로그인'}
          </button>
        </form>

        <p className="login-foot">© 2026 AceTec Co., Ltd.</p>
      </div>
    </div>
  );
}
